import React, { Component } from 'react'
import { Button } from "react-bootstrap";
import { ReactGA }  from './App';

require(`../assets/${process.env.PAGE}/css/components/WhatsappButton.css`)
class Whatsapp extends Component {

  constructor(props) {
    super(props);
    this.state = {
      number: "",
      message: "",
    };
    this.replaceSpaces = this.replaceSpaces.bind(this);
    this.onClick = this.onClick.bind(this);
  }

  trackGAEvent() {
    let gaEvent = {}
    if(this.props.gaCategory) gaEvent.category = this.props.gaCategory;
    if(this.props.gaAction)  gaEvent.action = this.props.gaAction;
    if(this.props.gaValue) gaEvent.value = parseInt(this.props.gaValue, 10);
    if(this.props.gaLabel) gaEvent.label = this.props.gaLabel;
    ReactGA.event(gaEvent);
  }

  onClick() {
    if(this.props.gaEvent) this.trackGAEvent()
  }

  replaceSpaces(text) {
    this.setState({ message: text.replace(/\s/g, "%20") })
  }

  componentWillMount() {
    const { number, text } = this.props;

    number && this.setState({ number: number })
    text && this.replaceSpaces(text)
  }

  render() {
    return (
      <div className="fixed-wp-div">
        <Button className="nextButton d-flex justify-content-center border-0 bg-transparent btn-primary" onClick={() => this.onClick()}>
          <a href={`https://wa.me/549${this.state.number}?text=${this.state.message}`} className="whatsapp" target="_blank" rel="noreferrer"><i className="fa fa-whatsapp whatsapp-icon"/></a>
        </Button>
      </div>
    )
  }
}

export default Whatsapp;


/** WEBPACK FOOTER **
 ** ./src/components/WhatsappButton.js
 **/